import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Engole o erro do DOM (causado por Google Translate / extensões) — em
    // produção é silencioso. Apenas loga em desenvolvimento.
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn("[ErrorBoundary]", error?.message, info?.componentStack);
    }
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="agenda-error-boundary"
          className="min-h-[60vh] flex flex-col items-center justify-center p-8 text-center"
        >
          <h2 className="text-xl font-medium mb-2">Tivemos um soluço ao renderizar essa tela.</h2>
          <p className="text-sm text-muted-foreground mb-4 max-w-md">
            Isso costuma acontecer quando o tradutor automático do navegador (Google Translate) está ativo.
            Desative a tradução para este site e recarregue.
          </p>
          <button
            data-testid="agenda-error-reload"
            onClick={this.handleReload}
            className="px-4 py-2 rounded-full bg-primary text-primary-foreground"
          >
            Recarregar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
